import { render, staticRenderFns } from "./AddImsGroupDialog.vue?vue&type=template&id=1f90f1f8&scoped=true&"
import script from "./AddImsGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AddImsGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90f1f8",
  null
  
)

export default component.exports